import * as url from 'url';
import getBasePath from './getBasePath';
import { getHostLocation } from './hostLocation';
import { parse } from 'querystring';

// Deeplink url without vdir, e.g.: deeplink/, 0/deeplink/
const DEEPLINK_URL =
    getBasePath()
        .split('/')
        .slice(1)
        .join('/') + 'deeplink/';

/**
 * Get url for popout window, e.g. /mail/deeplink/compose
 * @param vdir Vdir of the popout window, either mail or calendar
 * @param route Route of the popout window, e.g. compose
 * @param skipOptInCheck Whether skip optIn check. When set to true, a param "minus" will be added to the url
 * @param parameters Additional parameters to put into querystring
 */
export default function getPopoutUrl(
    vdir: 'mail' | 'calendar',
    route: string,
    skipOptInCheck?: boolean,
    parameters?: Record<string, string | undefined>
) {
    let search = getHostLocation().search;

    if (skipOptInCheck) {
        // Adding "minus" as query parameter will skip optIn check and enable deeplink for users
        // who are opted-in to People app but not to Mail app
        parameters = parameters || {};
        parameters.minus = '';
    }

    if (parameters) {
        // Remove leading '?' from search string, then parse it
        const paramPairs: Record<string, string | undefined> = parse((search || '').substr(1));
        Object.keys(parameters).forEach(key => (paramPairs[key] = parameters![key]));
        search = '?' + stringify(paramPairs);
    }

    let deepLinkUrl = `/${vdir}/${DEEPLINK_URL}`;

    const popoutUrl = {
        pathname: deepLinkUrl + route,
        search,
    };

    return url.format(popoutUrl);
}

function stringify(parameters: Record<string, string | undefined>): string {
    return Object.entries(parameters)
        .map(([key, value]) =>
            !value
                ? encodeURIComponent(key)
                : `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join('&');
}
